import { ProfileInfo } from "shared/interfaces/myProfile";
import { Omit } from "@material-ui/core";
import urls from "shared/api/auth/urls";
import { httpGet } from "shared/api/apiHandler";

type ProfileResponse = Omit<ProfileInfo, "additionalDetails"> & { additionalDetails: string };

export const getUserInfo = async (): Promise<ProfileInfo> => {
    const result = await httpGet<ProfileResponse>(window.APP_SETTINGS.authApiBaseUri, urls.CONNECT.USERINFO);

    return {
        ...result.data,
        additionalDetails: JSON.parse(result.data.additionalDetails),
    };
};
